<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button *ngIf="!visibilitySpinner" [disabled]="formInvalid" type="button" class="btn btn-outline-success" (click)="onSave()" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </form>
</nav>

<app-organismosnocivos-edit [organismoNocivo]="organismoNocivo" [listTiposOrganismoNocivo]="listTiposOrganismoNocivo" [formGroup]="formGroup.get('basic')" (back)="onBack()"></app-organismosnocivos-edit>
